import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { SelectListItem } from '../lib/select/select-property';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { AppService } from '../services/app.service';
import '../lib/string-extension';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { Resource } from '../model/access-right';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'app-access-right',
  templateUrl: './access-right.component.html',
  styleUrls: ['./access-right.component.css']
})
export class AccessRightComponent {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  ControllerName: string = 'AccessRight';
  ResourceAction : Resource[] = [];
  ddlRoles: SelectListItem[];
  Resources: any[] = [];
  Action: any[] = [];
  ActionNameList: string[] = [];
  selectedRoleId = '';
  userPermission: any;
  CanUpdate = false;

  constructor(private readonly dataSer: DataService, private readonly appService: AppService, private readonly dlgService: DialogService) {
    this.userPermission = this.appService.currentResource.subscribe(data => {
      this.CanUpdate = data.CanUpdate;
    });
  }

  OnDataSrvEnd() {
    setTimeout(() => { this.appService.SetLoadingState(false) }, 0);
  }

  ngOnInit() {
    setTimeout(() => this.appService.SetLoadingState(true), 0);
  }

  ngAfterViewInit() {
    this.getInit();
  }

  getInit(){
    this.dataSer.getData(this.ControllerName + '/getdata', null,
      (data) => {
        // Get Role List
        this.ddlRoles = [];
        let i = 0;
        data.Roles.forEach(it => {
          const o: SelectListItem = {
            value: it.RoleId,
            text: it.RoleName
          };

          // Set selected role
          if (i === 0) {
            this.selectedRoleId = it.RoleId;
          }

          this.ddlRoles.push(o);
          i++;
        });

        this.ResourceAction = data.ResourceActions;
        this.GetAccessRight();
      },(res) => {
      }, (data) => { });
  }

  GetAccessRight() {
    setTimeout(() => this.appService.SetLoadingState(true), 0);
    this.ResourceAction.forEach(r => {
      r.Selected = false;
      r.actions.forEach(a => a.Selected = false);
      r.Expanded = false;
    });
    this.accordion.closeAll();
    this.dataSer.getData(`${this.ControllerName}/${this.selectedRoleId}`, null,
      (data) => {
        data.DataList.forEach(ma =>{
          const resource = this.ResourceAction.find(r => r.ResourceID === ma.ResourceID);
          resource.actions.forEach(a => {
            if(ma.ActionID === a.ActionID) {
              a.Selected = true;
            }
          });
          this.updateAllSelected(ma.ResourceID);
          resource.Expanded = true;
        });
      }, (res) => {
    }, (data) => { this.OnDataSrvEnd(); });
  }

  updateAccessRight() {
    this.appService.SetLoadingState(true);
    let ActionChecked: string[] = [];
    this.ResourceAction.forEach(res => {
      res.actions.forEach(act => {
        if (act.Selected === true) {
          ActionChecked.push(act.ActionID);
        }
      });
    });

    this.dataSer.updateData(`${this.ControllerName}/${this.selectedRoleId}`, ActionChecked, (data) => {
      let result = this.dlgService.EditSubmit();
      result.then((ret) => {
      }).catch((error) => {
        console.error(error);
      });

    }, (res) => {
    }, (data) => { this.OnDataSrvEnd(); });
  }

  updateAllSelected(id: string) {
    const resource = this.ResourceAction.find(r => r.ResourceID === id);
    if (resource) {
      resource.Selected = resource.actions.every(action => action.Selected);
    }
  }

  someSelected(id: string): boolean {
    if (this.ResourceAction == null) {
      return false;
    }
    return this.ResourceAction.filter(r => r.ResourceID == id).some(r => r.actions.filter(a => a.Selected).length > 0 && !r.Selected);
  }

  selectAll(id: string, completed: boolean) {
    if (this.ResourceAction == null) {
      return;
    }
    this.ResourceAction.filter(r => r.ResourceID == id).forEach(a => a.Selected = completed);
    this.ResourceAction.filter(r => r.ResourceID == id).forEach(r => {
      r.actions.forEach(a => (a.Selected = completed));
    });
  }

}